/* ----------------------------------------------------------------------------
   WhatsApp Checkout
   Replaces the "add to cart / checkout" action with a redirect to the store's
   WhatsApp, pre-filling a message with the selected product, variant, quantity,
   price and link. Configured from Theme settings > WhatsApp.
---------------------------------------------------------------------------- */
(function () {
  'use strict';

  function sanitizeNumber(value) {
    return (value || '').replace(/\D/g, '');
  }

  function getSelectedVariantId(form) {
    if (!form) return null;
    // When the variant picker is a dropdown, the <select name="id"> is the source of truth.
    var select = form.querySelector('select[name="id"]');
    if (select && select.value) return select.value;
    // Otherwise the theme keeps the hidden <input name="id"> value up to date.
    var hidden = form.querySelector('input[name="id"]');
    return hidden ? hidden.value : null;
  }

  function getQuantity(form) {
    if (!form || !form.elements) return 1;
    var input = form.elements['quantity'];
    if (input && input.value) {
      var n = parseInt(input.value, 10);
      if (!isNaN(n) && n > 0) return n;
    }
    return 1;
  }

  function buildMessageUrl(host) {
    var number = sanitizeNumber(host.getAttribute('data-wa-number'));
    var intro = host.getAttribute('data-wa-message') || '';
    var title = host.getAttribute('data-product-title') || '';
    var url = host.getAttribute('data-product-url') || '';
    var defaultVariant = host.getAttribute('data-default-variant') === 'true';

    var form = host.closest('form');
    if (!form && host.getAttribute('data-form')) {
      form = document.getElementById(host.getAttribute('data-form'));
    }

    var variantId = getSelectedVariantId(form);
    var quantity = getQuantity(form);

    var variants = {};
    var dataScript = host.querySelector('script.wa-variants');
    if (dataScript) {
      try { variants = JSON.parse(dataScript.textContent); } catch (e) { variants = {}; }
    }
    var variant = variantId && variants[variantId] ? variants[variantId] : null;

    var lines = [];
    if (intro) { lines.push(intro); lines.push(''); }
    lines.push('*' + title + '*');
    if (variant && !defaultVariant && variant.title && variant.title !== 'Default Title') {
      lines.push('Variação: ' + variant.title);
    }
    lines.push('Quantidade: ' + quantity);
    if (variant && variant.price) lines.push('Preço: ' + variant.price);
    if (url) { lines.push(''); lines.push(url); }

    return 'https://wa.me/' + number + '?text=' + encodeURIComponent(lines.join('\n'));
  }

  if (window.customElements && !window.customElements.get('whatsapp-buy-button')) {
    window.customElements.define('whatsapp-buy-button', class extends HTMLElement {
      connectedCallback() {
        var trigger = this.querySelector('button, a');
        if (!trigger || trigger.dataset.waBound === 'true') return;
        trigger.dataset.waBound = 'true';

        var host = this;
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          if (trigger.hasAttribute('disabled') || trigger.getAttribute('aria-disabled') === 'true') return;
          if (!sanitizeNumber(host.getAttribute('data-wa-number'))) {
            console.warn('[WhatsApp] Número não configurado em Configurações do tema > WhatsApp.');
            return;
          }
          window.open(buildMessageUrl(host), '_blank');
        });
      }
    });
  }

  // Product cards (single-variant quick add) use a lightweight delegated handler.
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-wa-card]');
    if (!target) return;
    event.preventDefault();

    var number = sanitizeNumber(target.getAttribute('data-wa-number'));
    if (!number) return;

    var lines = [];
    var intro = target.getAttribute('data-wa-message') || '';
    if (intro) { lines.push(intro); lines.push(''); }
    lines.push('*' + (target.getAttribute('data-product-title') || '') + '*');
    lines.push('Quantidade: 1');
    var price = target.getAttribute('data-product-price');
    if (price) lines.push('Preço: ' + price);
    var url = target.getAttribute('data-product-url');
    if (url) { lines.push(''); lines.push(url); }

    window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(lines.join('\n')), '_blank');
  });

  // ---- Moodie delivery form (inside cart drawer) -------------------------------
  // Show/hide the address field depending on the "how to receive" choice.
  window.moodieToggleDelivery = function (select) {
    var wrap = document.getElementById('moodie-delivery');
    if (!wrap || !select) return;
    var deliveryVal = wrap.getAttribute('data-df-delivery') || 'Entrega';
    var addr = wrap.querySelector('[data-df-address]');
    if (addr) addr.style.display = (select.value === deliveryVal) ? '' : 'none';
  };
  // Fallback binding (in case inline handler is stripped on re-render).
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('#moodie-wa-receive');
    if (sel) window.moodieToggleDelivery(sel);
  });

  function readDelivery() {
    var wrap = document.getElementById('moodie-delivery');
    if (!wrap) return { present: false, valid: true, data: {} };
    var deliveryVal = wrap.getAttribute('data-df-delivery') || 'Entrega';
    function val(id) { var el = document.getElementById(id); return el ? (el.value || '').trim() : ''; }
    var data = {
      receive: val('moodie-wa-receive'),
      zone: val('moodie-wa-zone'),
      name: val('moodie-wa-name'),
      address: val('moodie-wa-address'),
      notes: val('moodie-wa-notes')
    };
    var errors = [];
    if (!data.name) errors.push('moodie-wa-name');
    if (data.receive === deliveryVal && !data.address) errors.push('moodie-wa-address');
    var valid = errors.length === 0;
    var errEl = wrap.querySelector('[data-df-error]');
    if (errEl) {
      if (valid) { errEl.hidden = true; errEl.textContent = ''; }
      else { errEl.hidden = false; errEl.textContent = wrap.getAttribute('data-df-error-msg') || 'Preencha os campos obrigatórios.'; }
    }
    if (!valid) { var bad = document.getElementById(errors[0]); if (bad) bad.focus(); }
    return { present: true, valid: valid, data: data, deliveryVal: deliveryVal };
  }

  // Pedido mínimo (em centavos). O valor vem do carrinho Moodie
  // (Personalizar > Moodie • Carrinho > Pedido mínimo); se não achar, usa R$ 25,00.
  function getMinOrderCents() {
    var el = document.querySelector('[data-min-order]');
    var cents = el ? parseInt(el.getAttribute('data-min-order'), 10) : NaN;
    return isNaN(cents) ? 2500 : Math.max(0, cents);
  }
  function setMinOrderMessage(btn, text) {
    var parent = btn.parentNode;
    if (!parent) return;
    var msg = parent.querySelector('[data-wa-min-msg]');
    if (!text) { if (msg) msg.parentNode.removeChild(msg); return; }
    if (!msg) {
      msg = document.createElement('p');
      msg.setAttribute('data-wa-min-msg', '');
      msg.setAttribute('role', 'alert');
      msg.style.cssText = 'margin:0 0 10px;color:#c81d3c;font-weight:700;font-size:.9rem;text-align:center;';
      parent.insertBefore(msg, btn);
    }
    msg.textContent = text;
  }

  // Cart (drawer + cart page): send the whole cart to WhatsApp.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-wa-cart]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var number = sanitizeNumber(btn.getAttribute('data-wa-number'));
    if (!number) return;
    var intro = btn.getAttribute('data-wa-message') || '';

    // Validate the delivery form BEFORE opening WhatsApp.
    var delivery = readDelivery();
    if (delivery.present && !delivery.valid) return;

    function appendDelivery(lines) {
      if (!delivery.present) return lines;
      var d = delivery.data;
      lines.push('');
      lines.push('*Dados de entrega:*');
      if (d.receive) lines.push('Forma: ' + d.receive);
      if (d.zone) lines.push('Região: ' + d.zone);
      if (d.name) lines.push('Nome: ' + d.name);
      if (d.address && d.receive === delivery.deliveryVal) lines.push('Endereço: ' + d.address);
      if (d.notes) lines.push('Obs: ' + d.notes);
      return lines;
    }

    function openWith(lines) {
      window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(lines.join('\n')), '_blank');
    }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        function fmt(cents) {
          try {
            return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: cart.currency });
          } catch (e) {
            return (cents / 100).toFixed(2);
          }
        }

        var lines = [];
        if (intro) { lines.push(intro); lines.push(''); }

        if (!cart.items || cart.items.length === 0) {
          openWith(appendDelivery(lines.length ? lines : ['Olá! Gostaria de fazer um pedido.']));
          return;
        }

        // Pedido mínimo: abaixo do valor, NÃO envia para o WhatsApp.
        var minCents = getMinOrderCents();
        if (minCents > 0 && cart.total_price < minCents) {
          setMinOrderMessage(btn, 'Pedido mínimo: ' + fmt(minCents) + '. Faltam ' + fmt(minCents - cart.total_price) + ' para finalizar.');
          return;
        }
        setMinOrderMessage(btn, '');

        lines.push('*Pedido:*');
        cart.items.forEach(function (item, i) {
          var name = item.product_title || item.title || '';
          var variant = (item.variant_title && item.variant_title !== 'Default Title') ? ' - ' + item.variant_title : '';
          lines.push((i + 1) + ') ' + name + variant + ' (x' + item.quantity + ') - ' + fmt(item.final_line_price));
        });
        lines.push('');
        lines.push('Total: ' + fmt(cart.total_price));
        appendDelivery(lines);
        openWith(lines);
      })
      .catch(function () {
        openWith(appendDelivery(intro ? [intro] : ['Olá! Gostaria de fazer um pedido.']));
      });
  });
})();